import {makeStyles} from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
	iconsList: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		color: '#646b6f',
	},
	active: {
		color: '#283339',
	},
	icon: {
		marginLeft: 7,
	},
}));